<ion-grid class="container">
  <ion-row class="claim">
    <ion-col size-xs="12" size-sm="8">
      <ion-note class="label">{{ 'SECTIONS.TITLE' | translate }}</ion-note>
      <h2 class="title">{{ 'SECTIONS.CLAIM' | translate }}</h2>
    </ion-col>
  </ion-row>
  <ion-row class="subsections">
    <nav>
      <ion-button
        *ngIf="publicName$ | async as publicName"
        [languageRouter]="['el-centro']"
        routerDirection="root"
        fill="clear"
        [ngClass]="{ activeSection: section === 'mallInfo' }"
      >
        {{ 'SECTIONS.ABOUT' | translate : { tenantName: publicName } }}
      </ion-button>

      <ion-button [languageRouter]="['tu-negocio-aqui']" routerDirection="root" fill="clear"
        [ngClass]="{ activeSection: section === 'yourBusinessHere' }">
        {{ 'SECTIONS.YOUR_BUSINESS' | translate }}
      </ion-button>

      <ion-button [languageRouter]="['como-llegar']" routerDirection="root" fill="clear"
        [ngClass]="{ activeSection: section === 'directions' }">
        {{ 'SECTIONS.DIRECTIONS' | translate }}</ion-button>
      <ion-button [languageRouter]="['compromiso']" routerDirection="root" fill="clear"
        [ngClass]="{ activeSection: section === 'commitment' }">
        {{ 'SECTIONS.COMMITMENT' | translate }}</ion-button>
      <ion-button [languageRouter]="['sostenibilidad']" routerDirection="root" fill="clear"
        [ngClass]="{ activeSection: section === 'sustainability' }">
        {{ 'SECTIONS.SUSTAINABILITY' | translate }}</ion-button>

      <ion-button [languageRouter]="['contacto']" routerDirection="root" fill="clear"
        [ngClass]="{ activeSection: section === 'contact' }">
        {{ 'SECTIONS.CONTACT' | translate }}</ion-button>
    </nav>
  </ion-row>
</ion-grid>
<div class="section-image" [style.backgroundImage]="'url(' + image + ')'">
  <div class="gradient"></div>
</div>
